import { render, staticRenderFns } from "./AjoutCategorieCheval.vue?vue&type=template&id=22f80baf&"
import script from "./AjoutCategorieCheval.vue?vue&type=script&lang=js&"
export * from "./AjoutCategorieCheval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports